var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPieceJointe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 25,
    viewBox: "0 0 16 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 15.9502V7.70117C14.75 5.91096 14.0388 4.19407 12.773 2.9282C11.5071 1.66233 9.79021 0.951172 8 0.951172C6.20979 0.951172 4.4929 1.66233 3.22703 2.9282C1.96116 4.19407 1.25 5.91096 1.25 7.70117V18.9512C1.25 20.1446 1.72411 21.2892 2.56802 22.1332C3.41193 22.9771 4.55653 23.4512 5.75 23.4512C6.94347 23.4512 8.08807 22.9771 8.93198 22.1332C9.77589 21.2892 10.25 20.1446 10.25 18.9512V7.70117C10.25 7.10443 10.0129 6.53214 9.59099 6.11018C9.16903 5.68822 8.59674 5.45117 8 5.45117C7.40326 5.45117 6.83097 5.68822 6.40901 6.11018C5.98705 6.53214 5.75 7.10443 5.75 7.70117V17.4512",
    stroke: "#162056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieceJointe);
export default __webpack_public_path__ + "static/media/piece-jointe.aa59639099c4b8d2b412bb0a4a1a8880.svg";
export { ForwardRef as ReactComponent };